import { consumirServicioEncirptacion } from 'api';
import DynamicTableDetail from 'components/Details/DynamicTableDetail';
import { IndexColumn } from 'components/Table/Columns';
import {
  emp,
  urlCertificadosEliminar,
  urlGetKardexCerificadosTbta,
} from 'constants/urls';
import useCustomRouter from 'hooks/useCustomRouter';
import useCustomToast from 'hooks/useCustomToasts';
import useUsuario from 'hooks/useUsuario';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import useDetallePoliza from 'redux/hooks/useDetallePoliza';
import FormCertificadoPoliza from './FormCertificadoPoliza';
import ModalDeleteCertificado from './ModalDeleteCertificado';

const HistorialCertificadosEmitidosPoliza = () => {
  const {
    planSeleccionado,
    diccionarios,
    setShowForm,
    showForm,
    certificados,
    setCertificadosProps,
    setStateDetallePoliza,
  } = useDetallePoliza();
  const [eliminando, setEliminando] = useState(false);
  const router = useCustomRouter();

  const [generandoReporte, setGenerandoReporte] = useState(false);

  const { addSuccessToast, addWarningToast } = useCustomToast();

  const { idPoliza, codPlan } = useParams();

  const usuario = useUsuario();

  const onClickAgregar = () => setShowForm(true);

  const onClickEliminar = async (rowData) => {
    console.log(rowData);
    const Data = {
      idCertificado: rowData.id,
      codusuario: usuario.cliCodigoCore,
    };
    setEliminando(true);
    const res = await consumirServicioEncirptacion(urlCertificadosEliminar, Data);
    console.log('RES: ', res);
    if (res?.transaccion) {
      setStateDetallePoliza(res?.poliza);
      setCertificadosProps(res);
      setEliminando(false);
      return addSuccessToast('Se ha eliminado el certificado correctamente');
    } else {
      return addWarningToast('Ha ocurrido un problema al eliminar el certificado');
    }
  };

  const onClickDescargarReporte = async (evt) => {
    console.log(evt);
    setGenerandoReporte(true);
    //'&empresa=' . $empresa . '&idPoliza=' . $id . '&codPlan=' . $codPlan
    const URL = `${urlGetKardexCerificadosTbta}&empresa=${emp}&idPoliza=${idPoliza}&codPlan=${codPlan}`;
    const res = await consumirServicioEncirptacion(URL, {});
    if (res?.transaccion) {
      setGenerandoReporte(false);
      return window.open(res.url);
    }
    setGenerandoReporte(false);
    return addWarningToast('Ha ocurrido un problema en la generación del documento');
  };

  return (
    <div className="row justify-content-center">
      <div className="col-11 col-lg-10">
        <h2>Información del plan seleccionado</h2>
      </div>

      <div className="col-11 col-lg-10">
        <DynamicTableDetail
          source={planSeleccionado}
          diccionario={diccionarios?.planSeleccionado}
        />
      </div>

      {!showForm && (
        <React.Fragment>
          <div className="col-11 col-md-11 d-flex flex-row justify-content-between">
            <h2 className="my-auto">Historial de certificados emitidos</h2>
            <div className="text-right">
              <button
                className="btn btn-primary btn-sm mx-1 my-1"
                style={{ width: '230px' }}
                onClick={onClickDescargarReporte}
                disabled={generandoReporte}
              >
                {!generandoReporte && 'DESCARGAR REPORTE'}
                {generandoReporte && 'GENERANDO REPORTE...'}
              </button>
              <button
                className="btn btn-primary btn-sm mx-1 my-1"
                style={{ width: '230px' }}
                onClick={onClickAgregar}
              >
                GENERAR CERTIFICADO
              </button>
              <button
                className="btn btn-primary btn-sm mx-1 my-1"
                style={{ width: '230px' }}
                onClick={router.goTo(`/carga-masiva/${idPoliza}/${codPlan}`)}
              >
                GENERACION MASIVA
              </button>
            </div>
          </div>

          <div className="col-11 col-md-11">
            <DataTable
              value={certificados}
              className="p-datatable-gridlines p-datatable-sm"
              rowHover
              emptyMessage="No hay certificados emitidos"
              resizableColumns
              autoLayout
              loading={eliminando}
            >
              {IndexColumn({ header: 'Certificado' })}
              <Column
                header="Pasajero"
                field="cliNombres"
                sortable
                bodyClassName="text-center"
              />
              <Column
                header="Fecha de emisión"
                field="fechaEmision"
                sortable
                bodyClassName="text-center"
              />
              <Column
                header="Fecha de vigencia desde"
                field="iniVigencia"
                sortable
                bodyClassName="text-center"
              />
              <Column
                header="Fecha de vigencia hasta"
                field="finVigencia"
                sortable
                bodyClassName="text-center"
              />
              <Column
                header="Duración"
                field="duracion"
                sortable
                bodyClassName="text-center"
              />
              <Column
                header="Destino"
                field="nomDestino"
                sortable
                bodyClassName="text-center"
              />
              <Column
                header="Descargar certificado"
                bodyClassName="text-center"
                body={(rowData) => {
                  if (!rowData?.certificado) return null;
                  return (
                    <React.Fragment>
                      <a
                        download
                        className="btn btn-primary btn-sm btn-block"
                        href={rowData.certificado}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Descargar certificado
                      </a>

                      {rowData.canDelete && (
                        <ModalDeleteCertificado
                          rowData={rowData}
                          onClickEliminar={onClickEliminar}
                        />
                      )}
                    </React.Fragment>
                  );
                }}
              />
            </DataTable>
          </div>
        </React.Fragment>
      )}

      {showForm && <FormCertificadoPoliza />}
    </div>
  );
};

export default HistorialCertificadosEmitidosPoliza;
